import { IconButton, styled } from '@mui/joy';

import { commonBaseButtonStyles } from '@components/BaseStyledComponents/common';

export const BaseIconButton = styled(IconButton)(({ theme }) => ({
  ...commonBaseButtonStyles(theme),
  padding: theme.spacing(1),
}));

export const BaseIconButtonForGroup = styled(IconButton)(({ theme }) => ({
  svg: {
    fill: theme.palette.isDarkMode
      ? theme.palette.neutral[900]
      : theme.palette.primary[700],
  },
  background: theme.palette.isDarkMode
    ? theme.palette.neutral[400]
    : theme.palette.primary[50],
  color: theme.palette.isDarkMode
    ? theme.palette.neutral[900]
    : theme.palette.primary[700],
  '&:hover': {
    background: theme.palette.isDarkMode
      ? theme.palette.neutral[500]
      : theme.palette.primary[100],
  },
  gap: theme.spacing(1),
  padding: theme.spacing(1),
}));
